import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class DownloadJitRemarkService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }

  execute({ queryParams }: { queryParams: { id: number } }) {
    return this._jitRepository.downloadJitRemark({ queryParams });
  }
}

export default new DownloadJitRemarkService({
  repository: jitRepository
});

export { DownloadJitRemarkService };
